import { Injectable } from '@angular/core';
import { CategoryChangesPanelComponent } from '@components/category-changes-panel/category-changes-panel.component';
import { ChannelChangesPanelComponent } from '@components/channel-changes-panel/channel-changes-panel.component';
import { ChannelGroupChangesPanelComponent } from '@components/channel-group-changes-panel/channel-group-changes-panel.component';
import { ChannelOverviewPanelComponent } from '@components/channel-overview-panel/channel-overview-panel.component';
import { CreatedFolderPanelComponent } from '@components/created-folder-panel/created-folder-panel.component';
import { FcuChangesPanelComponent } from '@components/fcu-changes-panel/fcu-changes-panel.component';
import { MimicsChangesPanelComponent } from '@components/mimics-changes-panel/mimics-changes-panel.component';
import { OpsChangesPanelComponent } from '@components/ops-changes-panel/ops-changes-panel.component';
import { OwnerChangesPanelComponent } from '@components/owner-changes-panel/owner-changes-panel.component';
import { VersionApproverPanelComponent } from '@components/version-approver-panel/version-approver-panel.component';
import { VersionChangeType } from 'icreate/common/models/version-change-panel';

@Injectable({
    providedIn: 'root',
})
export class VersionChangesPanelService {
    private panelMapping: { [key: string]: any } = {};

    constructor() {
        this.panelMapping[VersionChangeType.APPROVER] = VersionApproverPanelComponent;
        this.panelMapping[VersionChangeType.MIMICS] = MimicsChangesPanelComponent;
        this.panelMapping[VersionChangeType.CHANNELS] = ChannelChangesPanelComponent;
        this.panelMapping[VersionChangeType.CHANNEL_GROUP] = ChannelGroupChangesPanelComponent;
        this.panelMapping[VersionChangeType.CATEGORY] = CategoryChangesPanelComponent;
        this.panelMapping[VersionChangeType.CHANNEL_OVERVIEW] = ChannelOverviewPanelComponent;
        this.panelMapping[VersionChangeType.OPS] = OpsChangesPanelComponent;
        this.panelMapping[VersionChangeType.FCU] = FcuChangesPanelComponent;
        this.panelMapping[VersionChangeType.Owner] = OwnerChangesPanelComponent;
        this.panelMapping[VersionChangeType.CREATED] = CreatedFolderPanelComponent;
    }

    public getPanel(type: string) {
        if (type == null) {
            throw new Error(`Null type passed to ${VersionChangesPanelService.name}`);
        } else if (type in this.panelMapping) {
            return this.panelMapping[type];
        } else {
            throw new Error(`Invalid version change panel type: '${type}'`);
        }
    }
}
